<template>
  <span :style="wrapperStyle" class="photo-icon">
    <i
      :class="`photo-icon__inner--${type}`"
      :style="innerStyle"
      class="photo-icon__inner"
    />
  </span>
</template>

<script>
import unknownImage from "@/assets/unknown.jpg";
export default {
  name: "PhotoIcon",
  props: {
    type: {
      type: String,
      default: "round",
    },
    src: {
      type: String,
      required: true,
    },
    fallbackSrc: {
      type: String,
      default: unknownImage,
    },
    width: {
      type: [String, Number],
      default: 30,
    },
    height: {
      type: [String, Number],
      default: 30,
    },
  },
  computed: {
    wrapperStyle() {
      const width =
        typeof this.width === "string" ? this.width : this.width + "px";
      const height =
        typeof this.height === "string" ? this.height : this.height + "px";
      return {
        width: width,
        height: height,
      };
    },
    // airsim add 2026.11.04 사진 URL 에 ?fallback=none → 사진 없는 사람은 no_photo.jpg(200,본문) 대신 404(0바이트) → 다운로드/깜빡임 제거(아바타 요청 폭풍 제거). 직접 <photo-icon> 쓰는 화면 전역 적용
    srcWithFallback() {
      if (!this.src) return "";
      return this.src.indexOf("?") >= 0
        ? `${this.src}&fallback=none`
        : `${this.src}?fallback=none`;
    },
    innerStyle() {
      return {
        // "background-image": `url(${this.src}), url(${this.fallbackSrc})`,   ** airsim comments 2026.11.04 src 에 fallback=none 적용(srcWithFallback)으로 교체, 원본 보존 **
        "background-image": `url(${this.srcWithFallback}), url(${this.fallbackSrc})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.photo-icon {
  height: 30px;
  width: 30px;
  padding: 0;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
  .photo-icon__inner {
    background-color: transparent;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;

    display: flex;
    flex: 1 1 100%;
    height: 100%;
    width: 100%;
    &--round {
      border-radius: 50%;
    }
    &:after {
      background-color: transparent;
      bottom: 0;
      content: " ";
      left: 0;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }
  }
}
</style>
